import React from 'react'
import styles from './CafeFirstView.module.css'
import { CafeFirstViewProps, CafeFirstViewVariant } from './types'

const VARIANTS: Record<CafeFirstViewVariant, { src: string; alt: string; width: number; height: number }> = {
    hero: {
        src: '/pages/abtest/dev3390/firstview_cafe.jpg',
        alt: '今すぐ働けるカフェ求人見つかります！ 飲食店正社員 求人数No.1 ※',
        width: 375,
        height: 231,
    },
    short: {
        src: '/pages/abtest/dev3390/firstview_cafe_short.jpg',
        alt: '飲食店正社員 求人数No.1 ※ カフェスタッフ・ベーカリー 他にも...',
        width: 375,
        height: 99,
    },
}

// DEV-3390のテストで出すFV。2つのvariantは画像・alt・高さだけが違うので1コンポーネントで兼ねる。
// AB判定は持たない（どのパターンで出すかは呼び出し側が決める。SlimFirstViewと同じ方針）。
// テスト終了時はこのディレクトリごと削除する。
export const CafeFirstView = ({ variant, dataViewLabel }: CafeFirstViewProps) => {
    const image = VARIANTS[variant]

    return (
        <section data-view-label={dataViewLabel}>
            <div className={styles.contentWrap}>
                <img
                    src={image.src}
                    alt={image.alt}
                    width={image.width}
                    height={image.height}
                />
            </div>
        </section>
    )
}

export default CafeFirstView
